module.exports = __webpack_public_path__ + "static/reporting-e45bc07d013eec4b170eb741c29f170c.png";